function getIssuerId(issuers, targetName) {
  const foundIssuer = issuers.find(
    (issuer) => issuer.issuerName === targetName,
  );
  return foundIssuer ? foundIssuer.issuerId : null;
}

export default getIssuerId;
